<template>
  <div class="ege-page small-scroll-bar small-scroll-bar--black">
    <lazy-hydrate when-visible>
      <ege2-banner
        @openModal="modal = $event"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ege2-why-we
        @openModal="modal = $event"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ege2-gift
        @openModal="modal = $event"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ege2-formats
        @openModal="modal = $event"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <external-new-benefits
        @openModal="modal = $event"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ege2-results
        @openModal="modal = $event"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ege2-success
        @openModal="modal = $event"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ege2-platform />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <su-faq />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <ege2-form />
    </lazy-hydrate>

    <school-new-breadcrumbs :breadcrumbs="breadcrumbs" />

    <ege2-modal
      v-if="modal"
      :modal="modal"
      @close="modal = null"
    />
  </div>
</template>

<script>
import HeadMixin from '@/mixins/HeadMixin';

import LazyHydrate from 'vue-lazy-hydration';
import SchoolNewBreadcrumbs from '~/components/v2/school-new/SchoolNewBreadcrumbs.vue';
import Ege2Banner from '~/components/v2/ege-2/Ege2Banner.vue';
import Ege2WhyWe from '~/components/v2/ege-2/Ege2WhyWe.vue';
import Ege2Form from '~/components/v2/ege-2/Ege2Form.vue';
import Ege2Gift from '~/components/v2/ege-2/Ege2Gift.vue';
import Ege2Formats from '~/components/v2/ege-2/Ege2Formats.vue';
import Ege2Results from '~/components/v2/ege-2/Ege2Results.vue';
import Ege2Success from '~/components/v2/ege-2/Ege2Success.vue';
import SuFaq from '~/components/v2/school-university/SuFaq.vue';
import Ege2Platform from '~/components/v2/ege-2/Ege2Platform.vue';
import Ege2Modal from '~/components/v2/ege-2/Ege2Modal.vue';
import ExternalNewBenefits from '../../components/v2/external-new/ExternalNewBenefits.vue';

export default {
  name: 'EgePage',
  components: {
    ExternalNewBenefits,
    Ege2Modal,
    Ege2Platform,
    SuFaq,
    Ege2Success,
    Ege2Results,
    Ege2Formats,
    Ege2Gift,
    Ege2WhyWe,
    Ege2Form,
    SchoolNewBreadcrumbs,
    Ege2Banner,
    LazyHydrate,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',
  scrollToTop: true,

  data: () => ({
    breadcrumbs: [
      { text: 'главная', to: '/' },
      { text: 'егэ', to: '/ege' },
    ],
    modal: null,

    // для head
    title: 'Курсы подготовки к ЕГЭ 2025 | Школьный Университет Синергия',
    // eslint-disable-next-line max-len,vue/max-len
    description: 'Подготовься к ЕГЭ по математике, русскому языку, обществознанию, биологии и другим предметам. Удобный формат, опытные преподаватели, профориентация, гарантия поступления',
    image: '/v2/ege-2/share-image-ege.jpg',
  }),
};
</script>

<style scoped lang="scss">
.ege-page {
  padding-top: calc(var(--scale) * 120);
  padding-bottom: calc(var(--scale) * 58);
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 128);

  font-family: 'Onest', sans-serif;

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 80);
    gap: calc(var(--scale) * 76);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }

  ::v-deep(.su-faq){
    h3,
    .su-faq__info p {
      color: #0E436C;
    }

    .su-faq__question_btn {
      svg path {
        stroke: #0E436C;
      }
    }
  }

  ::v-deep(.main-title) {
    position: relative;
    font-family: 'Onest', sans-serif;

    h2 {
      margin-bottom: calc(var(--scale) * 24);
      font-weight: 500;
      font-size: 5.375rem;
      line-height: 110%;
      letter-spacing: -0.04em;
      text-align: center;
      color: #0E436C;

      @include media-down($size-tablet) {
        font-size: 4rem;
      }

      span {
        color: #A7ABAC;
      }
    }
  }

  ::v-deep(.external-benefits) {
    .external-benefits__block h6 {
      color: #0E436C;
    }
  }

  ::v-deep(.su-faq) {
    background-color: #ffffff;
  }
}
</style>
